/* eslint-disable no-restricted-properties */

import type {RoundingMode} from 'src/internal/number-formatter/types';

const roundingModeToMethod = {
  floor: 'floor',
  ceil: 'ceil',
  expand: 'round',
  trunc: 'trunc',
} as const;

// Intl.NumberFormat is buggy with ceil and floor rounding so we round the number before passing it to the Intl formatter.
export default function fixRounding(
  number: number,
  maximumFractionDigits: number,
  roundingMode?: RoundingMode,
): number {
  if (!roundingMode) {
    return number;
  }

  const fractionDigits = maximumFractionDigits;
  const roundingMethod = roundingModeToMethod[roundingMode];

  return (
    Math[roundingMethod](number * Math.pow(10, fractionDigits)) /
    Math.pow(10, fractionDigits)
  );
}
